




import { default as Component } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import NonCommodityProductInfoWidget from '@/components/widgets/NonCommodityProductInfoWidget.vue';
import IocContainer from '@/container/IocContainer';
import SERVICES from '@/container/Services';
import Api from '../../interfaces/Api';
import Tracking from '@/interfaces/Tracking';
import Format from '@/interfaces/Format';
import ProductData from '@/interfaces/ProductData';
import NonCommodityBase from './NonCommodityBase.vue';

const ApiProvider = IocContainer.get<Api>(SERVICES.API);
const formatProvider = IocContainer.get<Format>(SERVICES.FORMAT);
const trackingProvider = IocContainer.get<Tracking>(SERVICES.TRACKING);

@Component({
  components: {
    'product-info': NonCommodityProductInfoWidget
  },
  filters: {
    date: formatProvider.date(),
    euro: formatProvider.euro(),
    euroFull: formatProvider.euroFull(),
    zip: formatProvider.zip()
  },
  props: {
    availableAddons: {},
    isFleet: {
      type: Boolean,
      default: false
    }
  }
})
export default class NonCommodityProductWidget extends NonCommodityBase {
  @Prop({ default: true }) loadingProducts!: boolean;
  @Prop({ default: false }) isSessionLoaded!: boolean;
  @Prop() public extendedDataParentKey!: string;

  public availableAddons;
  public isSubmitting = false;

  protected selectedProductCode: string | null | undefined = null;
  protected resumeSession = false;

  public get selectedProductData(): ProductData | null {
    return this.store.state.nonCommodityProductData;
  }

  public mounted(): void {
    if (this.products.length > 0) {
      this.onProductsLoaded();
    }
  }

  protected onProductsLoaded(): void {
    return;
  }

  @Watch('products')
  public productsLoaded(products: []): void {
    this.onProductsLoaded();
  }

  protected getProductByProductCode(productCode: string): ProductData | null {
    for (let i = 0; i < this.products.length; ++i) {
      if (this.products[i].productCode == productCode) {
        return this.products[i];
      }
    }
    return null;
  }

  public selectProduct(product: Record<any, any>): void {
    this.$emit('selectProduct', product);
  }

  get products(): ProductData[] {
    let products = JSON.parse(JSON.stringify(this.store.state.availableProducts));
    return products;
  }

  public productSubmit(): void {
    const currentYear = new Date().getFullYear();
    if (this.thgConfig.availableYears.length === 1 && this.thgConfig.availableYears[0] === currentYear) {
      this.thgConfig.selectedYear = currentYear.toString();
    }
    if (
      this.selectedProductData &&
      this.selectedProductData.productCode &&
      this.selectedProductData.productCode.length > 0
    ) {
      this.isSubmitting = true;
      const data = {
        productCode: this.selectedProductData.productCode
      };
      ApiProvider.sessionUpdate(data)
        .then(() => {
          trackingProvider.thgProductSelected(
            this.selectedProductData,
            this.thgConfig.selectedVehicleTypeIdentifier,
            this.thgConfig.isCustomerTypeBusiness
          );
          this.$emit('productSubmit', data);
          this.isSubmitting = false;
          this.store.dispatch('setNonCommodityProduct', this.selectedProductData);
        })
        .catch((error) => {
          if (typeof error.response !== 'undefined' && error.response.data.error.message === 'session outdated') {
            localStorage.removeItem(process.env.VUE_APP_SESSION_STORAGE_KEY);
            window.location.href = document.referrer || window.location.origin;
          }
          this.isSubmitting = false;
        });
    }
  }

  public startFleetFlow() {
    this.store.commit('SET_IS_FLEET_FLOW', true);
    this.$emit('scrollToTop');
  }
}
